import React from 'react'
import { Link } from 'react-router-dom'
import { format as formatDate } from 'date-fns'
import { get } from 'lodash'
import { Heading, Text, VStack } from '@chakra-ui/react'
import { LeadGroupUser } from '@homevest/types/rental-applications'
import { UNDERWRITING_METHODOLOGIES } from '@homevest/utils/rental-applications'

import LeadType from 'components/LeadType'

type UserInfoProps = {
  firestoreUser: any
  hasSigned: boolean
  leadGroupUser: LeadGroupUser
  underwritingMethodology: string
}

const UserInfo: React.FC<React.PropsWithChildren<UserInfoProps>> = ({
  leadGroupUser,
  firestoreUser,
  hasSigned,
  underwritingMethodology
}) => {
  const user = leadGroupUser.users
  const creditScore =
    get(leadGroupUser, 'users.successful_credit_report.score') ||
    get(leadGroupUser, 'users.credit_report.score', 'N/A')
  const hasSubmittedApplication = !!leadGroupUser.rental_application_submitted_at

  const showVerifiedCredit = underwritingMethodology !== UNDERWRITING_METHODOLOGIES.SAFERENT

  return (
    <div>
      <VStack alignItems={'flex-start'} spacing={0} gap={0}>
        <Heading size='lg' justifyContent={'space-between'} as='h2'>
          <span>
            <Link to={`/users/${user.id}`} target='_blank' rel='noopener noreferrer'>
              {user.first_name} {user.last_name}
            </Link>
          </span>
        </Heading>
        {hasSigned && <span style={{ color: '#CCC' }}>Signed Lease</span>}
        {hasSubmittedApplication && (
          <Text color='gray' as='i'>
            Submitted application on{' '}
            {leadGroupUser.rental_application_submitted_at
              ? formatDate(new Date(leadGroupUser.rental_application_submitted_at), 'M/d/yy h:mm a')
              : 'N/A'}
          </Text>
        )}
      </VStack>
      <div style={styles.userDiv}>
        <div style={{ width: '33%' }}>
          <LeadType leadGroupUser={leadGroupUser} />
        </div>
        <UserInfoItem label='Email' value={user.email2} />
        <UserInfoItem label='Phone' value={user.phone2 || 'N/A'} />
      </div>
      <div
        style={{
          ...styles.userDiv,
          justifyContent: showVerifiedCredit ? 'space-between' : 'flex-start'
        }}
      >
        {showVerifiedCredit && <UserInfoItem label='Verified Credit' value={creditScore} />}
        <UserInfoItem
          label='Date of Birth'
          value={get(firestoreUser, 'underwriting.dateOfBirth', 'N/A')}
        />
        <UserInfoItem
          label='Current Address'
          value={get(firestoreUser, 'underwriting.currentAddress.formatted', 'N/A')}
        />
      </div>
    </div>
  )
}

const styles = {
  userDiv: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px'
  }
}

const UserInfoItem: React.FC<
  React.PropsWithChildren<{ label: string; value: string | null; width?: string }>
> = ({ label, value, width = '33%' }) => {
  return (
    <div style={{ width }}>
      <Text fontSize='xs'>{label}</Text>
      <Text marginTop={0}>{value ?? ''}</Text>
    </div>
  )
}

export default UserInfo
